import { MinimizedCall } from "./MinimizedCall";

export default MinimizedCall;
